import { FilterType, FacetValue } from '@app/core/search/filtering/types';

export class ParamParser {
  parse(filter: FilterType, value: string): FacetValue {
    switch (filter) {
      case FilterType.RefinementList:
        return this.parseList(value);

      case FilterType.StarRating:
      case FilterType.NumericSelector:
      case FilterType.NumericRefinementList:
        return this.parseNumeric(value);

      case FilterType.Toggle:
        return this.parseToggle(value);
    }

    return value;
  }

  parseList(value: string): string[] {
    // match sub category with special char : "t-shirt", "Kleidungsstücke" or "small bags, wallets & cases" ...
    // '(\d+\W)*' is added to avoid removing nubmers in specific brand and model facet name like '30 Montaigne' or '3.1 Phillip Lim'
    const match = value.match(/((\d+\W)*[a-zA-Z][a-zA-Z/\W]*#[0-9]+( > [a-zA-Z][a-zA-Z/\W]*#[0-9]+)*)/g);

    return match || value.split('-');
  }

  parseNumeric(value: string): number {
    return parseFloat(value);
  }

  parseToggle(value: string): boolean {
    return value === '1';
  }
}
